import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Locale from '../../domain/Locale';
import Color from '../../domain/Color';
import SponsorDomain from '../../domain/Sponsor';
import Layout from '../../components/Layout';
import Sponsor from '../../components/Sponsor';
import Message from '../../components/Message';
import HTMLComponent from '../../components/HTMLComponent';
import MarkdownComponent from '../../components/MarkdownComponent';
import SocialLogins from '../../components/SocialLogins';
import RegisterHeader from '../../components/header/Register';
import Email from '../../domain/Email';
import template from 'lodash/string/template';
import getConditions from '../../util/getConditions';
import getPolicy from '../../util/getPolicy';
import { t, props } from 'tcomb-react';

const FormType = t.struct({
  email: Email
});

let ThirdPartiesFormType;

const value = process.env.NODE_ENV !== 'production' ?
  {
    email: 'verified@domain.com',
    password: 'verified'
  } :
  {};

const thirdPartiesFormValues =  process.env.NODE_ENV !== 'production' ?
  {
    privacy_rcs: 'true',
    privacy_other: 'true',
    privacy_tracking: 'true'
  } :
  {};

@props({
  locale: Locale,
  message: t.maybe(t.Str),
  hasThirdPartiesPrivacy: t.maybe(t.Bool),
  sponsor: t.maybe(SponsorDomain),
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  goFacebook: t.maybe(t.Func),
  goGoogle: t.maybe(t.Func),
  goMicrosoft: t.maybe(t.Func),
  goTwitter: t.maybe(t.Func),
  doRegister: t.maybe(t.Func),
  doAcceptCookies: t.Func,
  goProduct: t.maybe(t.Func),
  goCatalog: t.maybe(t.Func),
  goLogin: t.Func,
  partners: t.maybe(t.Obj)
})
export default class Register extends React.Component {

  constructor(...args) {
    super(...args);
    this.state = {
      options: this.getOptions(),
      thirdPartiesFormOptions: this.getThirdPartiesFormOptions()
    };
  }

  getBgColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.bg_color;
  }

  getColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.color;
  }

  getOptions() {
    return {
      auto: 'none'
    };
  }

  getSxContent() {
    const bundle = get_bundle(this.props.locale).register;
    return (
      <div className="left-image">
        <div className="left-claim">
          <div className="cell">
            <MarkdownComponent>{bundle.claim.call_to_action}</MarkdownComponent>
          </div>
          <div className="cell">
            <MarkdownComponent>{bundle.claim.safe}</MarkdownComponent>
          </div>
        </div>
      </div>
    );
  }

  getThirdPartiesFormOptions() {
    const {locale} = this.props;
    const bundle = get_bundle(locale).register;

    const bool = t.enums({
      true: <strong><HTMLComponent>{bundle.accept}</HTMLComponent></strong>,
      false: <HTMLComponent>{bundle.no_accept}</HTMLComponent>
    });

    ThirdPartiesFormType = t.struct({
      privacy_rcs: bool,
      privacy_other: bool,
      privacy_tracking: bool
    });

    return {
      fields: {
        privacy_rcs: {
          label: <HTMLComponent>{bundle.privacy_rcs}</HTMLComponent>,
          factory: t.form.Radio
        },
        privacy_other: {
          label: <HTMLComponent>{bundle.privacy_other}</HTMLComponent>,
          factory: t.form.Radio
        },
        privacy_tracking: {
          label: <HTMLComponent>{bundle.privacy_tracking}</HTMLComponent>,
          factory: t.form.Radio
        }
      }
    };
  }

  onSubmit = (evt) => {
    evt.preventDefault();
    const value = this.refs.form.getValue();
    if (value) {
      if (this.props.hasThirdPartiesPrivacy) {
        var valueThirdParties = this.refs.thirdPartiesForm.getValue();
        if (valueThirdParties) {
          this.props.doRegister(value.email, valueThirdParties.privacy_rcs, valueThirdParties.privacy_other, valueThirdParties.privacy_tracking);
        }
      }
      else {
        this.props.doRegister(value.email, null, null, null);
      }
    }
  }

  getSponsor() {
    const options = {
      is_welcome: true,
      showTutorial: false
    };
    return (<Sponsor sponsor={this.props.sponsor} locale={this.props.locale} options={options} />);
  }

  getMessage() {
    const message = this.props.message ? this.props.message : get_bundle(this.props.locale).register.message;
    return (<Message bgColor={this.props.themeBgColor} fontColor={this.props.themeBgFontColor}>{message}</Message>);
  }

  getThirdPartiesForm() {
    if ( !this.props.hasThirdPartiesPrivacy ) {
      return null;
    }
    return (
      <div id="form_third_parties" className="box light">
        <form>
          <HTMLComponent>{get_bundle(this.props.locale).register.third_parties_privacy_intro}</HTMLComponent>
          <t.form.Form
            ref="thirdPartiesForm"
            type={ThirdPartiesFormType}
            options={this.state.thirdPartiesFormOptions}
            value={thirdPartiesFormValues} />
        </form>
      </div>
    );
  }

  getDisclaimer() {
    const {locale} = this.props;
    const bundle = get_bundle(locale).landing;
    const disclaimer = template(bundle.do_register_hint)({
      button: bundle.do_register,
      conditions: getConditions(locale),
      policy: getPolicy(locale)
    });

    return (
      <div className='disclaimer'>
        <small>
          <HTMLComponent>
            {disclaimer}
          </HTMLComponent>
        </small>
      </div>
    );
  }

  getHeader() {
    return (<RegisterHeader
      goCatalog={this.props.goCatalog}
      goProduct={this.props.goProduct}
      goLogin={this.props.goLogin}
      locale={this.props.locale}
      color={this.getColor()}
      themeBtnColor={this.props.themeBtnColor}
      themeBtnFontColor={this.props.themeBtnFontColor} />);
  }

  render() {
    const {locale} = this.props;
    const bundle = get_bundle(locale).landing;
    const doRegisterStyle = {
      backgroundColor: this.props.themeBtnColor,
      color: this.props.themeBtnFontColor
    };
    return (
      <Layout header={this.getHeader()} partners={this.props.partners} sponsor={this.getSponsor()} bgColor={this.getBgColor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <div id="register">
          <div className="cols">
            <div className="large-60 small-hide ">
              <div className="cell">
                { this.getSxContent() }
              </div>
            </div>
            <div className="large-40 medium-40 large-pull-right medium-pull-right small-100">
              <div className="cell">
                <div className="actions">
                  { this.getMessage() }
                  <SocialLogins
                      title={bundle.go_logins}
                      goFacebook={this.props.goFacebook}
                      goGoogle={this.props.goGoogle}
                      goTwitter={this.props.goTwitter}
                      goMicrosoft={this.props.goMicrosoft}
                      goLogin={this.props.goLogin} />
                  <div id="form" className="box light">
                    <h2 className="">{bundle.do_register_title}</h2>
                    <form onSubmit={this.onSubmit}>
                      <t.form.Form
                        ref="form"
                        type={FormType}
                        options={this.state.options}
                        value={value} />
                      <button id="do_register" className="btn" style={doRegisterStyle}>{bundle.do_register}</button>
                      {this.getDisclaimer()}
                    </form>
                  </div>
                  {this.getThirdPartiesForm()}
                </div>

              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/Register.js
 **/